const InputNumbers = {

	init: function() {
		let self = this;

		Array.prototype.slice.call(document.querySelectorAll('.js-input-number')).forEach((input) => {
			self.create(input);
		});
	},

	create: function(_real) {
		if (_real.dataset.initialized) {
			return;
		}

		_real.dataset.initialized = '1';

		// -------------------------------------------------------------------------------------------------------------
		// building elements

		let container = document.createElement('div');
		container.classList.add('c-input-number');

		let decrease = document.createElement('button');
		decrease.type = "button";
		decrease.classList.add('c-input-number__control');
		decrease.classList.add('c-input-number__control--decrease');
		decrease.innerText = '-';

		let increase = document.createElement('button');
		increase.type = "button";
		increase.classList.add('c-input-number__control');
		increase.classList.add('c-input-number__control--increase');
		increase.innerText = '+';

		let fake = document.createElement('input');
		fake.classList.add('c-input-number__input');
		fake.type = 'text';
		fake.value = getValue() + '';
		fake.placeholder = _real.placeholder;

		container.appendChild(decrease);
		container.appendChild(fake);
		container.appendChild(increase);

		_real.parentNode.insertBefore(container, _real.nextSibling);
		_real.classList.add('c-input-number__real-input');

		// -------------------------------------------------------------------------------------------------------------
		// controlling logic

		function commit(value) {
			commitFake(value);
			commitReal(value);
		}

		function commitReal(value) {
			let update = value !== _real.value;
			_real.value = value;

			if (update) {
				_real.dispatchEvent(new CustomEvent('change'));
			}
		}

		function commitFake(value) {
			fake.value = value + '';
		}

		function getMin() {
			return parseFloat(_real.min);
		}

		function getMax() {
			return parseFloat(_real.max);
		}

		function getStep() {
			let step = parseFloat(_real.step);
			return isNaN(step) ? 1.0 : step;
		}

		function getValue() {
			let value = parseFloat(_real.value + '');
			let min = getMin();
			let max = getMax();

			value = isNaN(value) ? 0.0 : value;

			if (! isNaN(min) && value < getMin()) {
				value = getMin();
			}

			if (! isNaN(max) && value > getMax()) {
				value = getMax();
			}

			return value;
		}

		function stepDown() {
			let value = getValue();
			let step = getStep();
			let min = getMin();

			value = value - step;
			if (! isNaN(min) && value < min) {
				value = min;
			}

			commit(value);
		}

		function stepUp() {
			let value = getValue();
			let step = getStep();
			let max = getMax();

			value = value + step;
			if (! isNaN(max) && value > max) {
				value = max;
			}

			commit(value);
		}

		decrease.addEventListener('click', function () {
			stepDown();
			return false;
		});

		increase.addEventListener('click', function () {
			stepUp();
			return false;
		});

		fake.addEventListener('keydown', function (event) {
			if (event.key === 'Down' || event.key === 'ArrowDown') {
				stepDown();
			}

			if (event.key === 'Up' || event.key === 'ArrowUp') {
				stepUp();
			}

			if (event.ctrlKey) {
				return true;
			}

			let allowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'Delete', 'Home', 'End', 'PageUp', 'PageDown', 'Left', 'Right', 'ArrowLeft', 'ArrowRight'];
			if (getStep() % 1 !== 0.0) {
				allowed.push('.', ',');
			}

			if (allowed.indexOf(event.key) === -1) {
				event.preventDefault();
				return false;
			}

			let hasDecPoint = ((fake.value.indexOf('.') !== -1 ? 1 : 0) + (fake.value.indexOf(',') !== -1 ? 1 : 0)) > 0;
			if (['.', ','].indexOf(event.key) !== -1 && hasDecPoint) {
				event.preventDefault();
				return false;
			}

			return false;
		});

		fake.addEventListener('keyup', function () {
			if (fake.value % getStep() !== 0.0) {
				commit(
					Math.floor(fake.value / getStep()) * getStep()
				);

				return;
			}

			// remove leading zero
			if (fake.value > 1.0 && fake.value.charAt(0) === '0') {
				fake.value = fake.value.substr(1);
			}

			commitReal(fake.value);
		});
	}
};

InputNumbers.init();

document.addEventListener('LokiRequestEnd', function () {
	InputNumbers.init();
});
